declare var $: any;

export function arrowOpenCloseHandler() {
    $('.toogle-arrow-open-close').click(function () {
        $(this).find('.pj-ico').not($(this).find('.pj-ico')).addClass('rotate-0').removeClass('rotate-180-againts-clockwise');
        $(this).find('.pj-ico').toggleClass('rotate-0 rotate-180-againts-clockwise');
    });
}

export function collapseGroupDropdown() {

    $('.collapse-fieldset-group .fieldset-body').each(function (i) {

        $(this).attr('id', 'fieldset-body' + i);

        var hrefFB = $(this).attr('id');

        $(this).closest('.collapse-fieldset').find('.fieldset-header a').attr({
            href: '#' + hrefFB,
            "data-toggle": 'collapse'
        });
    });

    $('.collapse-fieldset-group').each(function (i) {
        $(this).attr('id', 'collapse-fieldset-group' + i);
    });
}

export function rw() {
    var wWidth = $(window).innerWidth();

    if (window.innerWidth != wWidth) {
        if (wWidth < 768) {
            $('#db-search-filters, #ads-search-filters, #teacher-ads-search-filters, #teacher-ad-search-secundary-filters, #school-search-filters, #admin-search-filters').collapse('hide');
            heightRemoveTalkSidebarCardGroup();
        }
    }

    if (768 <= wWidth) {
        $('#db-search-filters, #ads-search-filters, #teacher-ads-search-filters, #teacher-ad-search-secundary-filters, #school-search-filters, #admin-search-filters').collapse('show');
        heightCalcTalkSidebarCardGroup();
    }
}

function heightRemoveTalkSidebarCardGroup() {
    var talkCardGroup = $('.talk-page-sidebar .talk-card-group');
    talkCardGroup.css('max-height', '');
}

function heightCalcTalkSidebarCardGroup() {
    var talkCardGroup = $('.talk-page-sidebar .talk-card-group');
    var wrapTalkCard = $('.talk-page-sidebar .wrap-talk-card');
    var mainContentHeight = $('.talk-page-main-content > div:visible').height();
    var valHWrapTalkCard = [];
    var sumHWrapTalkCard = 0;

    wrapTalkCard.each(function () {
        var thisH = $(this).outerHeight(true);
        valHWrapTalkCard.push(thisH);
    });

    for (var i = 0, leng = valHWrapTalkCard.length; i < leng; i++) {
        sumHWrapTalkCard += valHWrapTalkCard[i];
    }

    if (mainContentHeight * 0.63 <= sumHWrapTalkCard) {
        talkCardGroup.css('max-height', mainContentHeight * 0.68);
    }
    else {
        heightRemoveTalkSidebarCardGroup();
    }
}

export function initDropdownFilter(id: string) {
    $(`#${id}-search`).keyup(dropdownInputFilter);
    initDropdownFilterGeneric(id);
}


export function initCollapseDropdownFilter(id: string) {
    $(`#${id}-search`).keyup(dropdownCollapseInputFilter);
    initDropdownFilterGeneric(id);
}

function initDropdownFilterGeneric(id: string) {
    $(`#${id}-dp`).on('hidden.bs.dropdown', clearInputDropdown);
    $(`#${id}-dp`).on('show.bs.dropdown',
        () => {
            setTimeout(() => {
                $(`#${id}-search`).focus()
            }, 0);
        });
}

function dropdownInputFilter() {
    var filter = $(this).val().toUpperCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    var checkboxItem = $(this).closest('.dropdown-input-filter').find('.checkbox-group .wrap-checkbox');
    var noResultCtn = $(this).closest('.dropdown-menu-filter').find('.no-result-ctn');
    var noResultCtnMultiFilter = $(this).closest('.dropdown-input-filter').find('.no-result-ctn');
    var dropdownMultiInputFilter = $(this).closest('.dropdown-filter').hasClass('dropdown-multi-input-filter');

    var countItemShow = checkboxItem.length;

    checkboxItem.each(function (i) {
        var checkboxLabelText = $(this).find('.checkbox-label, .radio-label').text().toUpperCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");

        if (checkboxLabelText.indexOf(filter) > -1) {
            checkboxItem[i].style.display = '';
            countItemShow++;
        }

        else {
            checkboxItem[i].style.display = 'none';
            countItemShow--;
        }
    });

    $(this).closest('.dropdown-menu').find('.checkbox-group').each(function () {
        var wrapCheckboxCount = $(this).find('.wrap-checkbox').length;

        $(this).find('.wrap-checkbox').each(function () {

            var display = $(this).css('display');

            if (display == 'none') {
                wrapCheckboxCount--;
            }

            else {
                wrapCheckboxCount++;
            }
        });

        if (wrapCheckboxCount !== 0) {
            $(this).find('.group-heading').css('display', 'block');
        }

        else {
            $(this).find('.group-heading').css('display', 'none');
        }
    });

    if (dropdownMultiInputFilter) {
        if (countItemShow == 0) {
            noResultCtnMultiFilter.removeClass('d-none');
        }

        else {
            noResultCtnMultiFilter.addClass('d-none');
        }
    }

    else {
        if (countItemShow == 0) {
            noResultCtn.removeClass('d-none');
        }

        else {
            noResultCtn.addClass('d-none');
        }
    }
}

export function forceClearInputDropdown(id: string) {
    $(`#${id}`).find(`input`).val('');
    $(`#${id}`).find(`.wrap-checkbox`).css('display', '');
    $(`#${id}`).find(`.group-heading`).css('display', '');
    $(`#${id}`).find(`.no-result-ctn`).addClass('d-none');
    $(`#${id}`).find(`.similar-result-ctn`).addClass('d-none');
    $(`#${id}`).find(`.collapse-fieldset`).removeClass('d-none');
    $(`#${id}`).find(`.group-heading`).removeClass('d-none');
    $(`#${id}`).find(`.global-no-result-ctn`).addClass('d-none');
    $(`#${id}`).find(`.fieldset-header`).removeClass('d-none');
    $(`#${id}`).find(`.collapse-fieldset`).removeClass('d-none');;
    $(`#${id}`).find(`.collapsable-item`).removeClass('d-none');;
}


function clearInputDropdown() {
    $(this).find('input').val('');
    $(this).find('.wrap-checkbox').css('display', '');
    $(this).find('.group-heading').css('display', '');
    $(this).find('.no-result-ctn').addClass('d-none');
    $(this).find('.global-no-result-ctn').removeClass('d-none');
    $(this).find('.fieldset-header').removeClass('d-none');;
    $(this).find('.collapse-fieldset').removeClass('d-none');;
    $(this).find('.collapsable-item').removeClass('d-none');;
}

function dropdownCollapseInputFilter() {

    var filter = $(this).val().toUpperCase().trim().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    var checkboxItem = $(this).closest('.dropdown-input-tag-collapse').find('.checkbox-group .wrap-checkbox:not(.excluded)');
    var noResultCtn = $(this).closest('.dropdown-menu-filter').find('.global-no-result-ctn');
    var headers = $(this).closest('.dropdown-menu-filter').find('.fieldset-header');
    var similarResultCtn = $(this).closest('.dropdown-menu').find('.similar-result-ctn');
    var collapseItems = $('.collapsable-item');

    var countItemShow = checkboxItem.length;
    var countSameItem = 0;

    $(this).closest('.dropdown-input-tag-collapse').find('.fieldset-body').collapse('show');

    checkboxItem.each(function (i) {
        var checkboxLabelText = $(this).find('.checkbox-label, .radio-label').text().toUpperCase().trim().normalize("NFD").replace(/[\u0300-\u036f]/g, "");

        if (checkboxLabelText == filter) {
            countSameItem++;
        }

        if (checkboxLabelText.indexOf(filter) > -1) {
            checkboxItem[i].style.display = '';
            countItemShow++;
        }
        else {
            checkboxItem[i].style.display = 'none';
            countItemShow--;
        }
    });

    if (countItemShow == 0) {

        noResultCtn.removeClass('d-none');
        headers.addClass('d-none');

        collapseItems.each(function () {
            $(this).addClass('d-none');
        });
        similarResultCtn.addClass('d-none');
    }

    else {

        collapseItems.each(function () {
            $(this).removeClass('d-none');
        });

        noResultCtn.addClass('d-none');
        headers.removeClass('d-none');
        similarResultCtn.removeClass('d-none');
    }

    if ($(this).val().replace(/\s+/g, '') == '') {
        similarResultCtn.addClass('d-none');
    }

    if (countItemShow == 2 && countSameItem > 0) {
        similarResultCtn.addClass('d-none');
    }

    $(this).closest('.dropdown-input-tag-collapse').find('.fieldset-body').collapse('show');

    $(this).closest('.dropdown-menu-filter').find('.collapse-fieldset').each(function () {
        var checkCount = $(this).find('.wrap-checkbox').length;
        var checkVisibilityCount = 0;

        $(this).find('.wrap-checkbox').each(function () {
            var checkVisibility = $(this).css('display');

            if (checkVisibility == 'none') {
                ++checkVisibilityCount;
            }
        });

        if (checkVisibilityCount == checkCount) {
            $(this).addClass('d-none');
        }
        else {
            $(this).removeClass('d-none');
        }
    });
}

export function showLateralAdvancedFilters() {
    $(this).closest('form').find('.accordion-group .card:first .collapse:not(.no-collapse)').addClass('show');

    $('.show-lateral-advanced-filters').click(function () {
        $(this).closest('form').find('.lateral-filter-panel').addClass('show');
    });

    $('.btn-close-filter-panel').click(function () {
        $(this).closest('form').find('.lateral-filter-panel').removeClass('show');
    });
}

export function btnKanbanColSuggestedControl() {
    var kanbanComponent = $('.kanban-component');
    var kanbanComponentWrap = kanbanComponent.find('.wrap-kanban-col');
    var kanbanColSuggested = kanbanComponent.find('.kanban-col-suggested');
    var kanbanColSuggestedShow = kanbanComponent.find('.kanban-col-suggested').hasClass('show');

    if (!kanbanColSuggestedShow) {
        kanbanColSuggested.toggleClass('d-none');
        kanbanComponent.addClass('col-suggested-show');

        setTimeout(function () {
            kanbanColSuggested.toggleClass('show');
        }, 200);

        setTimeout(function () {
            fixKanbanHeightCols();
        }, 420);
    }

    else {
        kanbanColSuggested.toggleClass('show');
        kanbanComponent.find('.kanban-col:not(.kanban-col-suggested) .inner-section-body').css('max-height', '');
        kanbanComponent.removeClass('col-suggested-show');

        setTimeout(function () {
            kanbanColSuggested.toggleClass('d-none');
        }, 300);

        setTimeout(function () {
            fixKanbanHeightCols();
        }, 310);
    }

    var kanbanComponentWrapScroll = kanbanComponentWrap.scrollLeft();

    if (0 < kanbanComponentWrapScroll) {
        $('.kanban-component .wrap-kanban-col').scrollLeft(0);
    }
}

export function fixKanbanHeightCols() {

    var kanbanColInnerSectionBody = $('.kanban-component .kanban-col .inner-section-body');
    var kanbanColInnerSectionBodyPadding = parseFloat(kanbanColInnerSectionBody.css('padding'));
    var aplicantDragCardGroup = kanbanColInnerSectionBody.find('.aplicant-drag-card-group');
    var kanbanColSuggested = $('.kanban-component .kanban-col-suggested');
    // var kanbanColPsicoCta = $('.kanban-component .kanban-col-psico-interview .card-cta-1').innerHeight();
    // var kanbanColPsicoAlertCta = $('.kanban-component .kanban-col-psico-interview .alert-cta').innerHeight();
    var colSuggestedInnerSectionFooter = kanbanColSuggested.find('.inner-section-footer').innerHeight();
    var colSuggestedInnerSectionHeader = kanbanColSuggested.find('.checkbox-group-filters').innerHeight();
    var paddingFixWebkitBrowser = 10;

    var everyHeightInnerSectionBody = [400];

    kanbanColInnerSectionBody.css('min-height', '');
    kanbanColInnerSectionBody.css('max-height', '');

    kanbanColInnerSectionBody.each(function () {

        if ($(this).closest('.kanban-col').hasClass('kanban-col-suggested')) {
            var height = $(this).innerHeight() + colSuggestedInnerSectionFooter + colSuggestedInnerSectionHeader;
            everyHeightInnerSectionBody.push(height);
        }
        else {
            var height = $(this).innerHeight();
            everyHeightInnerSectionBody.push(height);
        }
    });

    var maxHeightInnerSectionBody = Math.max(...everyHeightInnerSectionBody);

    kanbanColInnerSectionBody.each(function () {

        if ($(this).closest('.kanban-col').hasClass('kanban-col-suggested')) {
            $(this).css('min-height', maxHeightInnerSectionBody - (colSuggestedInnerSectionFooter + colSuggestedInnerSectionHeader));
            $(this).css('max-height', maxHeightInnerSectionBody - (colSuggestedInnerSectionFooter + colSuggestedInnerSectionHeader));
        }

        else {
            $(this).css('min-height', maxHeightInnerSectionBody);
            $(this).css('max-height', maxHeightInnerSectionBody);
        }
    });

    everyHeightInnerSectionBody = [];

    aplicantDragCardGroup.css('min-height', '');

    var aplicantDragCardGroupHeight = maxHeightInnerSectionBody - (kanbanColInnerSectionBodyPadding * 2) - paddingFixWebkitBrowser;

    // aplicantDragCardGroup.each(function () {
    //     if ($(this).closest('.kanban-col').hasClass('kanban-col-psico-interview')) {
    //         $(this).css('min-height', aplicantDragCardGroupHeight - (kanbanColPsicoCta + kanbanColPsicoAlertCta));
    //     }

    //     else {
    //         $(this).css('min-height', aplicantDragCardGroupHeight);
    //     }
    // });
}

export function btnKanbanColDismissedControl() {
    var kanbanComponent = $('.kanban-component');
    var kanbanComponentWrap = kanbanComponent.find('.wrap-kanban-col');
    var kanbanColDismissed = kanbanComponent.find('.kanban-col.dismissed');
    var kanbanColDismissedShow = kanbanComponent.find('.kanban-col.dismissed').hasClass('show');

    if (!kanbanColDismissedShow) {
        kanbanColDismissed.toggleClass('d-none');
        kanbanComponent.addClass('col-suggested-show');

        setTimeout(function () {
            kanbanColDismissed.toggleClass('show');
        }, 200);

        setTimeout(function () {
            var scrollAmount = kanbanComponentWrap[0].scrollWidth - kanbanComponentWrap.width();

            $('.kanban-component .wrap-kanban-col').scrollLeft(scrollAmount);
            fixKanbanHeightCols();
        }, 480);
    }

    else {
        var scrollAmount = kanbanComponentWrap[0].scrollWidth - kanbanComponentWrap.width();

        $('.kanban-component .wrap-kanban-col').scrollLeft(scrollAmount);

        setTimeout(function () {
            kanbanColDismissed.toggleClass('show');
            kanbanComponent.removeClass('col-suggested-show');
        }, 200);

        setTimeout(function () {
            kanbanColDismissed.toggleClass('d-none');
        }, 480);

        setTimeout(function () {
            fixKanbanHeightCols();
        }, 490);
    }
}

export function btnKanbanColSuggestedControlCloseForce() {
    var kanbanComponent = $('.kanban-component');
    var kanbanColSuggested = kanbanComponent.find('.kanban-col-suggested');
    var kanbanColSuggestedShow = kanbanComponent.find('.kanban-col-suggested').hasClass('show');
    var btnLabelSuggested = $('.btn-control-kanban-col-suggested');
    var btnLabelShow = btnLabelSuggested.attr('data-btn-label-hide');

    if (kanbanColSuggestedShow) {

        kanbanColSuggested.toggleClass('show');
        kanbanComponent.find('.kanban-col:not(.kanban-col-suggested) .inner-section-body').css('max-height', '');
        kanbanComponent.removeClass('col-suggested-show');

        setTimeout(function () {
            kanbanColSuggested.toggleClass('d-none');
        }, 400);

        btnLabelSuggested.find('.btn-label').text(btnLabelShow);
    }

}

export function modalShow(modalName: string) {
    $("#" + modalName).modal('show');
}

